import { ProgressRing } from '@sparemin/blockhead';
import styled from 'styled-components';
import { ProjectLoaderProgressStyleProps } from './types';

export const Progress = styled(ProgressRing)<ProjectLoaderProgressStyleProps>`
  width: ${({ $size }) => ($size === 'large' ? '200px' : '100px')};
`;
